<template>
  <div class="el-input">
    <the-mask
      :mask="computedMask"
      class="el-input__inner"
      type="tel"
      autocomplete="off"
      name="account"
      :masked="true"
      :value="value"
      @input.native="updateInput($event)"
      ref="accountNumber" />
  </div>
</template>
<script>
import { TheMask } from 'vue-the-mask';
export default {
  components: { TheMask },
  props: {
    length:{
      type: Number,
      default: 17
    },
    value: {
      type: String,
      default: ''
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.autofocus ? this.$refs.accountNumber.$el.focus() : '';
    console.log(this.computedMask)
  },
  computed:{
    computedMask(){
      let count = this.length
      let mask = []
      while (count >= 6){
        let counter = count;
        let str = ''
        while (counter){
          str += '#'
          counter--;
        }
        mask.push(str)
        count--;
      }
      return mask
    },
  },
  methods: {
    updateInput(event) {
      let value = event.target.value;
      if (value) this.$emit('input', value.replace(/\D+/g, ''));
      else this.$emit('input', null);
    }
  }
};
</script>
<style lang="scss" scoped></style>
